import PropTypes from 'prop-types';
import { Stepper, Step, StepLabel } from '@mui/material';

const STEPS = ['Choose Data Type', 'Upload File', 'Preview & Import'];

// Visual progress tracker for the 3-stage flow, so a first-time user always
// knows what's done and what's next instead of reading three cards at once
// and guessing where to start.
const ImportStepper = ({ activeStep }) => (
  <Stepper activeStep={activeStep} alternativeLabel>
    {STEPS.map((label) => (
      <Step key={label}>
        <StepLabel>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
);

ImportStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

export default ImportStepper;
